import type { PresenceState } from '../domain/types'

// Presença do cliente no lobby (online/away/offline) — comportamento #8.
export function PresenceDot({ state, label = true }: { state: PresenceState; label?: boolean }) {
  const tone = state === 'online' ? 'success' : state === 'away' ? 'warning' : 'neutral'
  const text = state === 'online' ? 'No lobby' : state === 'away' ? 'Ausente' : 'Offline'
  return (
    <span className="fz-presence" title={`Cliente: ${text}`} aria-label={`Cliente: ${text}`}>
      <span className={`fz-dot fz-dot--${tone}`} aria-hidden="true" />
      {label && <span className="fz-presence__t" aria-hidden="true">{text}</span>}
    </span>
  )
}
